import { FC, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { loadClarityScript } from '../services/clarityService'

const Clarity: FC = (): React.ReactElement => {
  useEffect(() => {
    loadClarityScript()
  }, [])

  return <Outlet />
}

export default Clarity
